import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '@shared/models/api-response.model';
import { Rewards } from '@shared/models/rewards.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  
  totalGameBalance$ = new Subject<number>();
  memberBalance$ = new Subject<number>();
  memberUsername$ = new Subject<string>();

  reloadProviderEmmiter = new EventEmitter();
  subsVar: Subscription;

  constructor(
    private http: HttpClient
  ) { }

  refreshMemberBalance(amount?: number) {
    this.memberBalance$.next(amount);
  }

  reloadProvider() {
    this.reloadProviderEmmiter.emit();
  }

  refreshMemberName(username: string) {
    this.memberUsername$.next(username);
  }

  getActiveRewards(): Observable<Rewards[]> {
    return this.http.get<ApiResponse>(`/reward?active=1`).pipe(
      map(res => {
        return res.data.rows;
      }),
    );
  }
}
